import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { LearningPauseState } from '@core/constants/learning-pause.constant';

@JsonApiModelConfig({
  type: 'course_member_learning_pauses',
})
export class CourseMemberLearningPause extends JsonApiModel {
  @Attribute({ serializedName: 'course_activity_id' })
  courseActivityId!: number;

  @Attribute()
  state!: LearningPauseState;

  // ISO-8601 UTC strings.
  @Attribute({ serializedName: 'started_at' })
  startedAt!: string;

  @Attribute({ serializedName: 'unlock_at' })
  unlockAt!: string;

  @Attribute({ serializedName: 'completed_at' })
  completedAt!: string | null;

  @Attribute({ serializedName: 'waiting_days' })
  waitingDays!: number;
}
